import { defineComponent } from "vue";
import { controlStateStore } from "@/library/stores/ControlStateStore";
import InputBaseControl from "./InputBaseControl";
import { t } from "@/services/Translation/t";
export default defineComponent({
  name: "CheckBox",
  extends: InputBaseControl,
  data() {
    let store = controlStateStore(this.identifier as string);
    store.state.checked = false as boolean;
  },
  methods: {
    changeEvent() {
      if (!this.state.required) {
        this.state.value = this.state.checked == false ? "" : true;
      } else {
        this.state.value = this.state.checked;
      }
    },
    setValue(value: boolean) {
      this.state.value = value;
      this.state.checked = value;
    },
  },
  computed:{
    displayHint(): string {
      return t("Hint", this.identifier) + (this.displayRequiredCondition) ? this.displayRequiredText : "" ;
    },
  }
});
